import { render, staticRenderFns } from "./BaseMitMenuFooter.vue?vue&type=template&id=3d3c7daa&scoped=true"
import script from "./BaseMitMenuFooter.vue?vue&type=script&lang=js"
export * from "./BaseMitMenuFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c7daa",
  null
  
)

export default component.exports